import { functions, auth } from "./firebase";
import { httpsCallable } from "firebase/functions";

export async function checkAdminClaim() {
  const user = auth.currentUser;
  if (!user) return false;
  try {
    const tokenResult = await user.getIdTokenResult(true);
    return !!tokenResult.claims?.admin;
  } catch {
    return false;
  }
}

export async function adminGetCatalog() {
  try {
    const fn = httpsCallable(functions, "adminGetLibraryCatalog");
    const res = await fn({});
    if (res.data?.ok) {
      return { ok: true, books: res.data.books || [] };
    }
    return { error: "fail" };
  } catch (err) {
    if (err?.code === "functions/permission-denied" || err?.message?.includes("Admin")) {
      return { error: "unauthorized" };
    }
    return { error: "fail" };
  }
}

export async function adminSaveBook(book) {
  try {
    const fn = httpsCallable(functions, "adminSaveBook");
    const res = await fn({
      bookId: book.bookId,
      title: book.title,
      category: book.category,
      summary: book.summary,
      minutes: Number(book.minutes) || 0,
      status: book.status || "draft",
    });
    if (res.data?.ok) {
      return { ok: true, bookId: res.data.bookId };
    }
    return { error: "fail" };
  } catch (err) {
    if (err?.code === "functions/permission-denied") {
      return { error: "unauthorized" };
    }
    return { error: err?.message || "fail" };
  }
}

export async function adminSetBookStatus(bookId, status) {
  try {
    const fn = httpsCallable(functions, "adminSetBookStatus");
    const res = await fn({ bookId, status });
    if (res.data?.ok) {
      return { ok: true, bookId, status };
    }
    return { error: "fail" };
  } catch (err) {
    if (err?.code === "functions/permission-denied") {
      return { error: "unauthorized" };
    }
    return { error: err?.message || "fail" };
  }
}

export async function adminSaveChapter({ bookId, chapterId, title, minutes, tags, content }) {
  try {
    const fn = httpsCallable(functions, "adminSaveChapter");
    const res = await fn({
      bookId,
      chapterId,
      title,
      minutes: Number(minutes) || 5,
      tags: Array.isArray(tags) ? tags : (tags ? tags.split(",").map((s) => s.trim()).filter(Boolean) : []),
      content,
    });
    if (res.data?.ok) {
      return { ok: true, bookId, chapterId };
    }
    return { error: "fail" };
  } catch (err) {
    if (err?.code === "functions/permission-denied") {
      return { error: "unauthorized" };
    }
    return { error: err?.message || "fail" };
  }
}

export async function adminDeleteChapter(bookId, chapterId) {
  try {
    const fn = httpsCallable(functions, "adminDeleteChapter");
    const res = await fn({ bookId, chapterId });
    if (res.data?.ok) {
      return { ok: true, bookId, chapterId };
    }
    return { error: "fail" };
  } catch (err) {
    if (err?.code === "functions/permission-denied") {
      return { error: "unauthorized" };
    }
    return { error: err?.message || "fail" };
  }
}

export async function adminGetChapterMarkdown(bookId, chapterId) {
  try {
    const fn = httpsCallable(functions, "adminGetChapterMarkdown");
    const res = await fn({ bookId, chapterId });
    if (res.data?.ok) {
      return { ok: true, content: res.data.content };
    }
    return { error: "fail" };
  } catch (err) {
    if (err?.code === "functions/permission-denied") {
      return { error: "unauthorized" };
    }
    return { error: err?.message || "fail" };
  }
}
